/* eslint-disable @typescript-eslint/no-explicit-any */
type NamespaceFileUrl = `./locales/*/${string}.json`;
type NamespaceFile = Record<string, any>;

/**
 * A namespace is a all the language files for a specific namespace.
 * It's generated using vite's `import.meta.glob`, being on the format:
 * ```js
 * {
 *  './locales/en/namespace.json': {...},
 *  './locales/no/namespace.json': {...},
 * }
 * ```
 *
 * Therefore, before using as resources in i18next, it needs to be transformed to:
 * ```js
 * {
 *  en: {
 *   namespace: {...},
 *  },
 *  no: {
 *   namespace: {...},
 *  },
 * },
 * ```
 *
 * And then merged together with other namespaces.
 */
export type Namespace = Record<string, NamespaceFile>;

export const cart: Namespace = import.meta.glob<NamespaceFile>('./locales/*/cart.json' satisfies NamespaceFileUrl, {
    eager: true,
    import: 'default',
});

export const chat: Namespace = import.meta.glob<NamespaceFile>('./locales/*/chat.json' satisfies NamespaceFileUrl, {
    eager: true,
    import: 'default',
});

export const common: Namespace = import.meta.glob<NamespaceFile>('./locales/*/common.json' satisfies NamespaceFileUrl, {
    eager: true,
    import: 'default',
});

export const iam: Namespace = import.meta.glob<NamespaceFile>('./locales/*/iam.json' satisfies NamespaceFileUrl, {
    eager: true,
    import: 'default',
});

export const ourHistory: Namespace = import.meta.glob<NamespaceFile>(
    './locales/*/our-history.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);

export const salesforce: Namespace = import.meta.glob<NamespaceFile>(
    './locales/*/salesforce.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);

export const search: Namespace = import.meta.glob<NamespaceFile>('./locales/*/search.json' satisfies NamespaceFileUrl, {
    eager: true,
    import: 'default',
});

export const studieomaten: Namespace = import.meta.glob<NamespaceFile>(
    './locales/*/studieomaten.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);

export const studies: Namespace = import.meta.glob<NamespaceFile>(
    './locales/*/studies.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);

export const terms: Namespace = import.meta.glob<NamespaceFile>('./locales/*/terms.json' satisfies NamespaceFileUrl, {
    eager: true,
    import: 'default',
});
